import {
  PLAN_SELECTOR_TRANSLATIONS,
  PLAN_SELECTOR_ASSET,
  PLAN_SELECTOR_OFFERS,
} from '../actions/constantsActions';

const initialState = {
  translations: {},
  asset: {},
};

export default function planSelectorInfo(state = initialState, action) {
  switch (action.type) {
    case PLAN_SELECTOR_TRANSLATIONS:
      return { ...state, translations: action.translations };
    case PLAN_SELECTOR_ASSET:
      return { ...state, asset: action.asset };
    case PLAN_SELECTOR_OFFERS:
      return { ...state, offers: action.offers };
    default:
      return state;
  }
}
